import React, { useEffect, useState } from "react";
import SearchBar from "../../../components/admin/usable/SearchBar";
import AddButton from "../../../components/admin/usable/AddButton";
import Pagination from "@mui/material/Pagination";
import {
  deleteHotel,
  deleteTourOrder,
  getHotelList,
  hotelBooking,
  tourBookings,
} from "../../../api/admin/hotel";
import TableLoader from "../../../components/admin/usable/TableLoader";
import { Switch } from "@mui/joy";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import ViewButton from "../../../components/admin/usable/actions/ViewButton";
import { useNavigate } from "react-router";
import HotelOrderDetails from "./HotelOrderDetails";

const TourOrders = () => {
  const navigate = useNavigate();
  const [TourData, setTourData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [Search, setSearch] = useState("");
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(10);
  const [PageData, setPageData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    tourBookings(setTourData, Page, Limit, setPageData, setIsLoading);
  }, [Page, Limit]);

  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(TourData);
    } else {
      const result = TourData.filter((item) =>
        item.invoiceId.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }
  }, [Search, TourData]);
  const handleDelete = (item) => {
    const id = item.id;
    deleteTourOrder(setTourData, Page, Limit, setPageData, setIsLoading, id);
  };
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <SearchBar
          onChange={(e) => setSearch(e.target.value)}
          text="Search by Invoice Id"
        />
        <div></div>
      </div>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Invoice ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Tranx ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Tour Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Start Date
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                End Date
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Booked By
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Total Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Paid Amount
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Payment Status
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Payment Nature
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                CreatedAt
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Action
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {isLoading ? (
              <TableLoader colSpan={13} />
            ) : (
              <>
                {FilteredData.length > 0 ? (
                  <>
                    {FilteredData?.map((item, index) => {
                      return (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {index + 1}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.invoiceId}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.transactionId}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-balance">
                            {item.tourName}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.startDate.slice(0, 10)}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.endDate.slice(0, 10)}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.travellerName} <br /> {item.travellerPhone}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {" "}
                            {item.totalAmount || 0}BDT
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            {item.totalAmount || 0}BDT
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            <span
                              className={`px-2 py-1 ${
                                item.paymentStatus === "Paid"
                                  ? "bg-green-100 text-green-700"
                                  : "bg-orange-100 text-orange-700"
                              } rounded text-xs`}
                            >
                              {item.paymentStatus === "Paid"
                                ? "Paid"
                                : "Unpaid"}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-700">
                            <span
                              className={`px-2 py-1 ${
                                item.paymentNature === "Partial"
                                  ? "bg-orange-100 text-orange-700"
                                  : "bg-green-100 text-green-700"
                              } rounded text-xs`}
                            >
                              {item.paymentNature === "Partial"
                                ? "Partial"
                                : "Full"}
                            </span>
                          </td>

                          <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                            {item.createdAt.slice(0, 10)}
                          </td>
                          <td className="px-4 py-3 text-sm">
                            <div className="flex gap-x-2">
                              {/* <EditButton
                                onClick={() =>
                                  navigate(`/admin/hotel/edit/${item.hotelId}`)
                                }
                              /> */}
                              <DeleteButton
                                onClick={() => handleDelete(item)}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td
                      colSpan={13}
                      className="text-center py-5 text-gray-500 font-semibold"
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-xs">
          Showing {TourData.length} of {PageData} entries
        </p>
        <Pagination
          count={PageData || 1}
          page={Page}
          onChange={(event, value) => setPage(value)}
        />
      </div>
    </div>
  );
};

export default TourOrders;
